
import * as actionTypes from "../actionTypes";
import * as constants from "../Constatnts";
import axios from "axios";

export function getCustomRoles() {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;

      const response = await axios.get(
        `${constants.API_URL}/setup/customrole`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      let roles = [];

      if (response.data.code === "0") {
        roles = response.data.customRoles || [];
      }

      return roles;

    } catch (error) {
      console.error("Error fetching custom roles:", error);
      return [];
    }
  };
}


export function deleteCustomRoles(key) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;

      const response = await axios.delete(
        constants.API_URL + "/setup/customrole/" + key,
        {
          headers: {
            Authorization: "Bearer " + token,
          },
        }
      );

      if (
        response &&
        response.hasOwnProperty("data") &&
        response.data.hasOwnProperty("code") &&
        response.data.code === "0"
      ) {
        return true;
      } else {
        let message = "Failed to delete custom role";

        if (
          response &&
          response.hasOwnProperty("data") &&
          response.data.hasOwnProperty("message")
        ) {
          message = response.data.message;
        }

        alert(message);
        return false;
      }
    } catch (error) {
      console.error("Delete role error:", error);

      let message = "Error while deleting role";

      if (
        error &&
        error.hasOwnProperty("response") &&
        error.response.hasOwnProperty("data") &&
        error.response.data.hasOwnProperty("message")
      ) {
        message = error.response.data.message;
      }

      alert(message);
      return false;
    }
  };
}
// export function deleteCustomRoles(key) {
//   return (dispatch, getState) => {
//     return database
//       .collection("CustomRoles")
//       .doc(key)
//       .update({
//         IsDeleted: true,
//         ActionOn: firebase.firestore.FieldValue.serverTimestamp(),
//         ActionBy: getState().user.user.Name,
//         ActionByUID: getState().user.user.UID,
//         ActionByEmailID: getState().user.user.EmailID,

//         Action: constants.AUDIT_TRAIL_DELETE,
//       })
//       .then(() => {
//         return true;
//       });
//   };
// }



export function saveCustomRoles(customRole, key) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      let response = {};

      if (key !== "") {
        // Update existing account
        response = await axios.put(
          `${constants.API_URL}/setup/customrole/${key}`,
          customRole,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      } else {
        // Create new account
        response = await axios.post(
          `${constants.API_URL}/setup/customrole`,
          customRole,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      }

      if (response.data.code === "0") {
        if (key) {
          return key;
        } else {
          return key = getState().user.user.RegistrationID + "_" + customRole.Name;
        }
      }

      return null;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}
// export function saveCustomRoles(customRole, key) {
//   return async (dispatch, getState) => {
//     // console.log("customRole", customRole);
//     // console.log("key", key);
//     if (key.trim() !== "") {
//       database
//         .collection("CustomRoles")
//         .doc(key)
//         .update({
//           IsDeleted: false,
//           RegistrationID: getState().user.user.RegistrationID,
//           Action: constants.AUDIT_TRAIL_EDIT,
//           ActionOn: firebase.firestore.FieldValue.serverTimestamp(),
//           ActionBy: getState().user.user.Name,
//           ActionByUID: getState().user.user.UID,
//           ActionByEmailID: getState().user.user.EmailID,
//         });

//       for (let j = 0; j < customRole.Modules.length; j++) {
//         if (customRole.Modules[j].name === "Damage") {
//           console.log("Damage", customRole.Modules[j]);
//         }
//         database
//           .collection("CustomRoles")
//           .doc(key)
//           .collection("aclModules")
//           .doc(customRole.Modules[j].name)
//           .set(customRole.Modules[j]);
//       }
//       return key;
//     } else {
//       //console.log(customRole);
//       key = getState().user.user.RegistrationID + "_" + customRole.Name;
//       await database
//         .collection("CustomRoles")
//         .doc(key)
//         .set({
//           IsDeleted: false,
//           Role: customRole.Name,
//           RegistrationID: getState().user.user.RegistrationID,
//           ActionOn: firebase.firestore.FieldValue.serverTimestamp(),
//           ActionBy: getState().user.user.Name,
//           ActionByUID: getState().user.user.UID,
//           ActionByEmailID: getState().user.user.EmailID,
//           Action: constants.AUDIT_TRAIL_NEW,
//         });
//       for (let j = 0; j < customRole.Modules.length; j++) {
//         database
//           .collection("CustomRoles")
//           .doc(key)
//           .collection("aclModules")
//           .doc(customRole.Modules[j].name)
//           .set(customRole.Modules[j]);
//       }

//       return key;
//     }
//   };
// }

export function getCustomRoleDetails(key) {
  return async (dispatch, getState) => {
    try {
     const token = getState().user.uat;
      const response = await axios.get(
        `${constants.API_URL}/setup/customroledetail/${key}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
     
      
    return response.data.customRole;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}


export function getModulesForARole(key) {
  return async (dispatch, getState) => {
    try {
      const token = getState().user.uat;
      const response = await axios.get(
        `${constants.API_URL}/setup/customrole/${key}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      let modules = [];
      response.data.modules.forEach((doc) => {
        const { key, ...restData } = doc; // destructure to separate key
        let module = {
          name: key,  // assign key value to name
          ...restData // spread remaining data without key
        };
        modules.push(module);
      });
      
    return modules;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  };
}


